import React from "react"
import { Dropdown } from "semantic-ui-react" 

const FilterSortBy = ( { sort, onChange } ) => (
    <Dropdown
      trigger={<span><span className="dn dib-ns">Sortieren nach: </span> <span className="b">Artikel-Nr.</span></span>}>
      <Dropdown.Menu>
        <Dropdown.Item onClick={() => {
          onChange( "price" )
        }} text="Preis"/>
        <Dropdown.Item onClick={() => {
          onChange( "sort" )
        }} text="Art-Nr."/>
      </Dropdown.Menu>
    </Dropdown>
)
export default FilterSortBy


// WEBPACK FOOTER //
// ./src/theme/lucht-test/components/Filter/FilterSortBy.js